"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1531))
 * @trackcomponent
 * @donotsync Syncing adds default color (@quinlan.sokol)
 */
export const Shipping = createSVGIcon(
  <>
    <path
      d="M12.6665 10.5469H12.6655"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2187 21.6061C13.0456 21.6926 12.8557 21.7404 12.6623 21.7462C12.4689 21.7519 12.2766 21.7155 12.0987 21.6395L2.81067 17.6755C2.57017 17.573 2.3651 17.4021 2.22097 17.184C2.07683 16.9659 1.99999 16.7102 2 16.4488V7.3968C2.00003 7.14312 2.07244 6.89471 2.20871 6.68074C2.34498 6.46676 2.53946 6.29611 2.76933 6.1888L11.4773 2.1248C11.6424 2.04786 11.8215 2.00556 12.0036 2.00051C12.1857 1.99547 12.3669 2.02778 12.536 2.09547L21.1613 5.54613C21.4087 5.64498 21.6209 5.81568 21.7704 6.03622C21.9198 6.25677 21.9998 6.51704 22 6.78347V16.3901C21.9999 16.6377 21.9308 16.8803 21.8006 17.0908C21.6704 17.3014 21.4841 17.4715 21.2627 17.5821L13.2187 21.6061Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.667 10.5472L21.7497 6.00586"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.2373 6.63672L12.6653 10.5474V21.7434"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9747 8.39296L7.12939 4.1543"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Shipping",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
